import './assets/styles/index.scss';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebookSquare, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelopeOpen, faHatChef, faHourglass } from '@fortawesome/pro-regular-svg-icons';

library.add(faFacebookSquare, faInstagram, faWhatsapp);
library.add(faEnvelopeOpen, faHatChef, faHourglass);
